"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconPause = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M26.46 60.76h-7.95a1.6 1.6 0 0 1-1.6-1.6V10.84a1.6 1.6 0 0 1 1.6-1.6h8a1.59 1.59 0 0 1 1.6 1.6v48.32a1.6 1.6 0 0 1-1.65 1.6zm-6.35-3.2h4.75V12.44h-4.75zM51.49 60.76h-8a1.6 1.6 0 0 1-1.6-1.6V10.84a1.59 1.59 0 0 1 1.6-1.6h8a1.6 1.6 0 0 1 1.6 1.6v48.32a1.6 1.6 0 0 1-1.6 1.6zm-6.35-3.2h4.75V12.44h-4.75z"
  })),
  height: undefined,
  width: undefined
});
IconPause.displayName = 'IconPause';
var _default = IconPause;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/pause.js
// module id = 607
// module chunks = 0